const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế từng lần phát sinh ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên tổ chức có vốn chuyển nhượng",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức có vốn chuyển nhượng",
    },
    taxpayerCountry: {
      name: "taxpayerCountry",
      label: "[05] Quốc tịch",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn quốc tịch",
    },
    taxpayerAddress: {
      name: "taxpayerAddress",
      label: "[06] Địa chỉ trụ sở chính",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập địa chỉ trụ sở chính",
    },
    capitalTransfereeName: {
      name: "capitalTransfereeName",
      label: "[07] Tên tổ chức/cá nhân nhận vốn chuyển nhượng",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức/cá nhân nhận vốn chuyển nhượng",
    },
    capitalTransfereeCountry: {
      name: "capitalTransfereeCountry",
      label: "[08] Quốc tịch",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn quốc tịch",
    },
    capitalTransfereeAddress: {
      name: "capitalTransfereeAddress",
      label: "[09] Địa chỉ trụ sở chính",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập địa chỉ trụ sở chính",
    },
    capitalTransfereeTaxId: {
      name: "capitalTransfereeTaxId",
      label: "[10] Mã số thuế (nếu có)",
      type: "text",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[11] Tên đại lý thuế (nếu có)",
      type: "text",
    },
    taxAgentId: {
      name: "taxAgentName",
      label: "[12] Mã số thuế",
      type: "text",
    },
    enterprisesTransferredName: {
      name: "enterprisesTransferredName",
      label: "[14] Tên doanh nghiệp có vốn được chuyển nhượng",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên doanh nghiệp có vốn được chuyển nhượng",
    },
    enterprisesTransferredTaxId: {
      name: "enterprisesTransferredTaxId",
      label: "[15] Mã số thuế (nếu có)",
      type: "text",
    },
    contractNumber: {
      name: "contractNumber",
      label: "[16] Hợp đồng chuyển nhượng: Số:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập số hợp đồng chuyển nhượng",
    },
    contractDay: {
      name: "contractDay",
      label: "Ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày hợp đồng chuyển nhượng",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
